import { ApiClient, api } from '@sfs-projects/sfs-fc-api-sdk';
import env from "@/utils/env";

class SessionStorage {
    // store key/value pair
    async set(key: string, value: string): Promise<void> {
        localStorage.setItem(key, value);
    }

    // get value of
    async get(key: string): Promise<string> {
        const value = localStorage.getItem(key)
        return (value || '');
    }

    // delete key
    async remove(key: string): Promise<void> {
        localStorage.removeItem(key);
    }
}

class APICONFIG {
    static initConfig() {
        const sessionStorage = new SessionStorage();
        const config = {
            baseUrl: env.VUE_APP_API_URL,
            AUTH_SESSION_KEY: "AUTH_SESSION_KEY",
            session: sessionStorage
        };
        ApiClient.setApiConfig(config);
    }
}

export default APICONFIG;


